import React, { useEffect, useState } from "react";
import api from "../api";

// Label + key for every column of the uploaded HR salary sheet, in sheet order.
const FIELDS = [
  ["Present working days", "presentDays"], ["Gross salary", "gross_salary"], ["Actual gross by day", "actual_gross_by_day"],
  ["Basic & DA", "basic_da"], ["HRA", "hra"], ["Punctuality allowance", "punctuality_allowance"],
  ["Special allowance", "special_allowance"], ["Fixed allowance", "fixed_allowance"], ["Travel allowance", "travel_allowance"],
  ["Arrear", "arrear"], ["Reimbursement", "reimbursement"], ["BYOD", "byod"],
  ["Work deduction", "work_deduction"], ["Loan EMI", "loan_emi"], ["PF", "pf"], ["TDS", "tds"], ["GHI", "ghi"],
  ["Total addition", "total_addition"], ["Total deduction", "total_deduction"], ["Net salary", "net_salary"],
];
const monthLabel = (p) => { const [y, m] = p.split("-").map(Number); return new Date(y, m - 1, 1).toLocaleDateString("en-IN", { month: "long", year: "numeric" }); };
const fmt = (v) => (v == null || v === "" ? "—" : Number(v).toLocaleString("en-IN"));

// Month-wise salary sheet rows stored by Employees → Bulk Salary Upload.
export const EmployeeSalarySheet = ({ employeeId }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    let live = true;
    api.get(`/api/employees/${employeeId}/salary-sheet`).then(d => { if (live) setRows(Array.isArray(d) ? d : []); }).catch(() => { if (live) setRows([]); });
    return () => { live = false; };
  }, [employeeId]);
  if (!rows || rows.length === 0) return null;
  return <div className="mb-5 pb-5 border-b border-b0">
    <div className="text-[14px] font-bold text-t0 mb-2">Monthly Salary Sheet <span className="text-[12px] text-t3 font-normal">(from bulk salary upload)</span></div>
    {rows.map(r => <div key={r.period} className="mb-3 p-3 bg-bg2 border border-b0 rounded-[10px]">
      <div className="text-[14px] font-bold text-t0 mb-2">{monthLabel(r.period)}
        <span className="text-[12px] text-t3 font-normal ml-2">uploaded {new Date(r.uploadedAt).toLocaleDateString("en-IN")}{r.sourceFile ? ` · ${r.sourceFile}` : ""}</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-[10px]">
        {FIELDS.map(([label, k]) => <div key={k}><div className="text-[12px] text-t3 uppercase mb-[2px]">{label}</div><div className="text-[14px] text-t0 font-semibold">{fmt(r[k])}</div></div>)}
        <div><div className="text-[12px] text-t3 uppercase mb-[2px]">Bank account</div><div className="text-[14px] text-t0 font-semibold font-mono">{r.bank_account || "—"}</div></div>
        <div><div className="text-[12px] text-t3 uppercase mb-[2px]">IFSC</div><div className="text-[14px] text-t0 font-semibold font-mono">{r.ifsc_code || "—"}</div></div>
        <div><div className="text-[12px] text-t3 uppercase mb-[2px]">Yearly CTC (LPA)</div><div className="text-[14px] text-t0 font-semibold">{fmt(r.lpa)}</div></div>
      </div>
    </div>)}
  </div>;
};
